import React, { FunctionComponent } from 'react';
import Media from 'react-media';
import styled from 'styled-components';

import THEME from 'theme';
import { SCREEN } from 'scenes/common/types/screen';
import { Badge, Heading, Text } from 'components/chroma';
import { TextSmall } from 'components/chroma/extended';

const TICK_SYMBOL = String.fromCharCode(10003);

const ProgressSection = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
`;

const BadgeWrapper = styled.div`
  .c-badge--primary {
    background-color: ${THEME.BADGE.BACKGROUND.PRIMARY} !important;
    color: ${THEME.BADGE.TEXT.PRIMARY} !important;
  }
  .c-badge--secondary {
    background-color: ${THEME.BADGE.BACKGROUND.SECONDARY} !important;
    color: ${THEME.BADGE.TEXT.SECONDARY} !important;
  }
`;

const HeadingWrapper = styled.div`
  h1 {
    font-family: 'Source Sans Pro', sans-serif !important;
    line-height: 24px !important;
    font-weight: 700;
  }
`;

const FlowDescription: FunctionComponent<{
  isCurrentFlow: boolean;
  flowName: string;
}> = ({ isCurrentFlow, flowName }) => {
  if (isCurrentFlow) {
    return (
      <HeadingWrapper>
        <Heading
          size={1}
          margin={{ bottom: 0, right: 3 }}
          fontSize={{ xs: 14, sm: 16 }}
          textAlign="center"
        >
          {flowName}
        </Heading>
      </HeadingWrapper>
    );
  }

  return (
    <Media query={{ maxWidth: SCREEN.SMALL }}>
      {(matches) =>
        matches ? (
          <TextSmall margin={{ bottom: 0, right: 3 }}>{flowName}</TextSmall>
        ) : (
          <Text margin={{ bottom: 0, right: 3 }}>{flowName}</Text>
        )
      }
    </Media>
  );
};

const FlowIcon: FunctionComponent<{
  isCurrentFlow: boolean;
  flowName: string;
  isFlowComplete: boolean;
  flowNumber: number;
}> = ({ isCurrentFlow, flowName, isFlowComplete, flowNumber }) => (
  <BadgeWrapper>
    <Badge
      numbered
      primary={isCurrentFlow || isFlowComplete}
      secondary={!isCurrentFlow && !isFlowComplete}
      ariaLabel={`${flowNumber} ${flowName}`}
      margin={{ right: 2 }}
    >
      {isFlowComplete ? TICK_SYMBOL : flowNumber}
    </Badge>
  </BadgeWrapper>
);

const ProgressFlowBarItem: FunctionComponent<{
  flowNumber: number;
  flowName: string;
  isCurrentFlow: boolean;
  isFlowComplete: boolean;
}> = ({ flowNumber, flowName, isCurrentFlow, isFlowComplete }) => (
  <ProgressSection>
    <FlowIcon
      isCurrentFlow={isCurrentFlow}
      flowName={flowName}
      isFlowComplete={isFlowComplete}
      flowNumber={flowNumber}
    />
    <FlowDescription isCurrentFlow={isCurrentFlow} flowName={flowName} />
  </ProgressSection>
);

export default ProgressFlowBarItem;
